import { useMutation } from "@apollo/client"
import { RedeemInput, redeemMutation } from "./redeem.mutation"

export const useRedeem = () => {
  const [mutate, { data, loading, error }] = useMutation<any, RedeemInput>(redeemMutation.query)
  const formattedData = data ? redeemMutation.mapFn(data) : undefined
  const formattedError = error?.message

  return {
    mutate,
    data: formattedData,
    loading,
    error: formattedError,
    mapFn: redeemMutation.mapFn,
  }
}